enum PermissionTypes {
  AssignProject = 0,
  Discounts = 1,
  PrePay = 2,
  SalesAgencyDistributors = 3,
  AllOrganizations = 4,
  AccessProjects = 5,
  CreateOrder = 6,
  AutoReleaseOrder = 7,
  SalesAgenciesFilter = 8,
  DeleteProject = 9,
  ResendAndModifyOrder = 10,
  EditAnotherUser = 11,
  ManageAllRoles = 12,
  ManageSalesReps = 13,
  ManageSalesAgencyAdministrators = 14,
  ManageDistributorAdministrators = 15,
  ManageProjectManagers = 16,
  CanResetPasswords = 17,
  ManageOrganizations = 18,
  ViewOrganizationsDiscountAndCommissionRates = 19,
  EditOrganizationsDiscountAndCommissionRates = 20,
  ViewOrganizationDetails = 21,
  EditOrganizationsDetails = 22,
  ManageOrganizationsShippingAddresses = 23,
  CreateQuotes = 24,
  DeleteQuotes = 25,
  MakeBomEdits = 26,
  AccessUsersList = 27,
  ResetOwnPassword = 28,
  SelectSpecialShippingMethod = 29,
  CanOverrideMaxDiscountRate = 30,
  CanCreateLockers = 31,
  CanReadJdeXml = 32,
  CanCreatePartitions = 33,
  CanCreateWashroomAccessories = 34,
  CanCreateProjects = 35,
  CanManageShippingUsers = 36,
  CanSeeFailedToUploadStatus = 37,
  CanRefreshBom = 38,
  ResourceCenterAdmin = 39,
  CanAccessOrganizationsSection = 40,
  CanRequestAnOrderDateChangeRequest = 41,
  CanReviewAnOrderDateChangeRequestPlanner = 42,
  CanFilterDateChangeRequestsBySalesAreaAndCustomerServiceEmployees = 43,
  CanGetDateChangeRequestEmailNotifications = 44,
  CanEditPrintedInstructionsPreference = 46,
  CanAccessPhenolic = 47,
  CanEditBOMMissingPartsProjects = 48,
  CanAddDryersAccessories = 49,
  CanAddSoapDispensersAccessories = 50,
  CanAddBabyChangingStationsAccessories = 51,
  CanAccessLeads = 52,
  CanFilterLeadsBySalesArea = 53,
  CanAccessAssignments = 54,
  CanUploadLeadAttachments = 55,
  CanAccessPlastic = 56,
  OverridePhenolicAccess = 57,
  OverridePlasticAccess = 58,
  CanViewCustomerTier = 59,
  CanSendQuoteAndSubmittalPackageEmail = 60,
  CanSendOrderAndSubmittalPackageEmail = 61,
  CanExportODRListToCSV = 62,
  CanExportUserOrganizationDetailsToCSV = 63,
  CanAccessEssentialProducts = 64,
  OverrideEssentialProductsAccess = 65,
  CanExpediteOrderDateChange = 66,
  OverrideCanExpediteOrderDateChange = 67,
  CanAutofillCoverSheetInfo = 68,
  CanAccessPriorityOne = 69,
  CanCreateLockersRoomByDrawing = 70,
}

export default PermissionTypes;
